import styles from './InformationFormsStyle.module.scss'
import FormButtons from "./FormButtons"
import { mainContext } from "../../context/context";
import React, { useState, useEffect } from "react";
import { baseUrl } from "../../common/constants"
import { toast } from "react-toastify";
import { getAdminToken, pageWrapper } from "../../utils/helpers";
import { Content } from "antd/es/layout/layout";
import { useLocation, useParams } from "react-router-dom";
import { Col, Form, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import { EditOutlined } from "@ant-design/icons";
import _axios from '../../utils/api/_axios';
import { SpecialInstructionsSchema, validateField } from './Validations/FormsValidations';

const SpecialInstructions = ({ isForm = true, patientId = null, claim = {}, fetchClaims, setSelectedClaim}) => {
    const {id} = useParams()
    const route = `/new-entry/details/${id}`
    const location = useLocation()
    const token = getAdminToken()
    const { currentTab , getFormData, formDataValues, errors, setErrors} = React.useContext(mainContext);
    const [isEditing, setIsEditing] = React.useState(true);
    const [message, setMessage] = useState("");
    const [isDisable,setIsDisable] = useState(false)
    const [formValues, setFormValues] = useState({ instruction1: "", instruction2: "" });
    const inputChangeHandler = (event) => {
        const { name, value } = event.target
        setFormValues({ ...formValues, [name]: value })
        const errorMessage = validateField(name, value, SpecialInstructionsSchema);
        setErrors({ ...errors, [name]: errorMessage });
        getFormData({
            ...formDataValues,
            specialInstruction: {
                ...formDataValues.specialInstruction,
                [name]: value
            }
        });
    }

    const map = (formValues) => {
        return {
            "updateProperty": "specialInstructions",
            "value": {
                "instruction1": formValues.instruction1,
                "instruction2": formValues.instruction2
            }
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsDisable(true);
        let claimId = sessionStorage.getItem("claimId");
        if(!patientId) {
            patientId = sessionStorage.getItem("patientId");
        }
        const { error } = SpecialInstructionsSchema.validate(formValues, { abortEarly: false });
  
        if (error) {
            const errorMessages = error.details.reduce((acc, detail) => {
                acc[detail.path[0]] = detail.message;
                return acc;
            }, {});
            setErrors(errorMessages);
            setIsDisable(false);
        } else {
          setErrors({});
          if (patientId && claim?._id) {
            claimId = claim?._id;
        }
        if (patientId && claimId) {
            try {
                let res = await fetch(`${baseUrl}/patients/${patientId}/claims/${claimId}`, {
                    method: "PUT",
                    body: JSON.stringify(map(formValues)),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': getAdminToken()
                    },
                    cache: "no-cache"
                });
                if (res.status === 200) {
                    toast("Successfully saved patient.", {
                        type: "success",
                        autoClose: 3000,
                    });
                    sessionStorage.removeItem("claimId");
                    setIsDisable(false);
                    currentTab(0);
                    if (!isForm) {
                        setIsEditing(false);
                    }
                    if(window.location.pathname === `/patient-info/${id}`){
                      // const response = fetchClaims(patientId);
                      // setSelectedClaim(response?.data?.payload?.find(claim => claim._id === claimId))
                      window.location.reload();
                    }
                } else {
                    toast("Unable to submit. Some error occured", {
                        type: "error",
                        autoClose: 3000,
                    });
                }
            } catch (err) {
                console.log(err);
            }
        }
        }
       
    }

    const setValues = (payload) => {
        setFormValues({
            "instruction1": payload.instruction1,
            "instruction2": payload.instruction2
        })
    }

    let fetchInitial = async (patientId, claim) => {
        let claimId = sessionStorage.getItem("claimId");
        if(!patientId) {
            patientId = sessionStorage.getItem("patientId");
        }
        if (patientId && claim?._id) {
            claimId = claim?._id;
            return claim.specialInstructions;
        }
        // Todo Pankaj, this will never be called, we can remove this soon
        if (patientId && claimId) {
            try {
                let res = await fetch(`${baseUrl}/patients/${patientId}/claims/${claimId}?title=specialInstructions`, {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': getAdminToken()
                    }
                });
                let resJson = await res.json();
                return resJson.payload;
            } catch (err) {
                console.log(err);
            }
        } else {
            (token && (window.location.pathname !== route && window.location.pathname !== '/open-access-patient')) && toast.warn("Please save the patient before adding any information to claim")
        }
    }

    const handleClose = () => {
        if (!isForm) {
            setIsEditing(false);
        }
    }

    useEffect(() => {
        setIsEditing(isForm);
        fetchInitial(patientId, claim).then((payload) => { if (payload) { setValues(payload) } });
    }, [])

    let fetchSpecialInstructonsInfo = async (patientId = "") => {
        if (patientId || id) {
        try {
          const URL = window.location.pathname === route ? `${baseUrl}/openAccess/${id}` : `${baseUrl}/patients/${patientId}`
          const response = await _axios.get(URL);
          let renderResponse = location.pathname === route ? response.data?.payload?.specialInstruction : response.data?.payload
          if (response.status === 200) {
            // TODO pankaj, remove all irrelevant set messages and use toast message
            setMessage("User created successfully");
          } else {
            setMessage("Some error occured");
          }
          return renderResponse;
        } catch (err) {
          console.log(err);
        }
        }
      };

    const mapAPIDataToFormData = (payload) => {
        return {
          patientId: payload.patientId,
          instruction1: payload.instruction1,
          instruction2: payload.instruction2
        };
      }

    const setPatientValues = (patient) => {
        const formPayload = { ...patient, patientId: patient?._id }
        setFormValues(mapAPIDataToFormData(formPayload));
      };

      useEffect(() => {
        if (window.location.pathname === route) {
            fetchSpecialInstructonsInfo().then((payload) => {
               if (payload) setPatientValues(payload);
            });
        }
      }, []);


    const formRender=()=>{
        return (
            <form className={`${isEditing ? "bg-gray-100 shadow-md rounded-lg p-6 mb-6" : "bg-white border border-gray-300 rounded-lg p-6 mb-6"}`} onSubmit={handleSubmit}>
            <div className="flex justify-between items-center bg-gray-600 text-white p-4 rounded-t-lg">
              <h4 className="text-lg font-semibold">Special Instructions</h4>
              {!isEditing && (
                <div className="cursor-pointer hover:text-gray-200" onClick={() => setIsEditing(true)}>
                  <EditOutlined className="text-xl" />
                </div>
              )}
            </div>
          
            <div className="border border-gray-300 bg-white rounded-lg p-4 shadow-sm">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {isEditing ? (
                  <>
                    <Form.Item label="Instruction 1:" className="w-full">
                      <TextArea 
                        rows={3} 
                        className="w-full border border-gray-300 rounded p-2" 
                        value={formValues?.instruction1 || ""} 
                        placeholder="Instruction 1" 
                        name="instruction1" 
                        onChange={inputChangeHandler} 
                      />
                    </Form.Item>
                    <Form.Item label="Instruction 2:" className="w-full">
                      <TextArea 
                        rows={3} 
                        className="w-full border border-gray-300 rounded p-2" 
                        value={formValues?.instruction2 || ""} 
                        placeholder="Instruction 2" 
                        name="instruction2" 
                        onChange={inputChangeHandler} 
                      />
                    </Form.Item>
                  </>
                ) : (
                  <>
                    <div><b>Instruction 1:</b> {formValues?.instruction1 || ""}</div>
                    <div><b>Instruction 2:</b> {formValues?.instruction2 || ""}</div>
                  </>
                )}
              </div>
            </div>
          
            {isEditing && (
              <div className="flex justify-end mt-4">
                <FormButtons handleClose={handleClose} isDisable={isDisable} />
              </div>
            )}
          </form>
          
        )
    }

    return (
        <Content>
           {formRender()}
        </Content>
    )
}

export default SpecialInstructions